<div class="cart-eventos-container">
    <form [formGroup]="form">
        <!-- Dados do Evento -->
        <app-card-content [headerColor]="false" [title]="'Dados do Evento'" [icon]="iconeDaSecao('Dados do Evento')" [subtitle]="subtituloDaSecao('Dados do Evento')">
            <div class="field">
                <label class="font-semibold block mb-2">Nome do Evento</label>
                <input pInputText formControlName="eventoNome" class="w-full" />
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div class="field">
                    <label class="font-semibold block mb-2">Público Previsto</label>
                    <input pInputText formControlName="eventoPublicoPrevisto" class="w-full" />
                </div>
                <div class="field md:col-span-1 md:col-start-2 md:col-end-3 md:col-span-1 col-span-1">
                    <label class="font-semibold block mb-2">Local Evento</label>
                    <input pInputText formControlName="eventoLocal" class="w-full" />
                </div>
                <div class="field">
                    <label class="font-semibold block mb-2">Natureza</label>
                    <input pInputText formControlName="eventoNatureza" class="w-full" />
                </div>
            </div>
        </app-card-content>

        <!-- Dados do Fare -->
        <app-card-content [headerColor]="false" [title]="'Dados do Fare'" [icon]="iconeDaSecao('Dados do Fare')" [subtitle]="subtituloDaSecao('Dados do Fare')">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div class="field">
                    <label class="font-semibold block mb-2">Data/Hora Início</label>
                    <p-inputmask formControlName="fareDataHoraInicio" mask="99/99/9999 99:99" placeholder="DD/MM/AAAA HH:MM" styleClass="w-full" />
                </div>
                <div class="field">
                    <label class="font-semibold block mb-2">Data/Hora Fim</label>
                    <p-inputmask formControlName="fareDataHoraFim" mask="99/99/9999 99:99" placeholder="DD/MM/AAAA HH:MM" styleClass="w-full" />
                </div>
                <div class="field">
                    <label class="font-semibold block mb-2">Fare</label>
                    <input pInputText formControlName="fareNumero" class="w-full" />
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div class="field md:col-span-2">
                    <label class="font-semibold block mb-2">Hospital de Referência</label>
                    <input pInputText formControlName="hospitalReferencia" class="w-full" />
                </div>
                <div class="field">
                    <label class="font-semibold block mb-2">CNPJ</label>
                    <p-inputmask formControlName="hospitalCnpj" mask="99.999.999/9999-99" placeholder="00.000.000/0000-00" styleClass="w-full" />
                </div>
            </div>
        </app-card-content>

        <!-- Pagamento -->
        @if (possuiPagamento()) {
            <app-card-content [headerColor]="false" [title]="'Pagamento'" [icon]="iconeDaSecao('Pagamento')" [subtitle]="subtituloDaSecao('Pagamento')">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div class="campo">
                        <span class="campo-label">Valor</span>
                        <strong class="campo-valor">{{ formatarValor(dados()?.valor) }}</strong>
                    </div>
                    <div class="campo">
                        <span class="campo-label">Valor Pago</span>
                        <strong class="campo-valor">{{ formatarValor(dados()?.valorPago) }}</strong>
                    </div>
                    <div class="campo">
                        <span class="campo-label">Nosso Número</span>
                        <strong class="campo-valor">{{ valorOuTraco(dados()?.nossoNumero) }}</strong>
                    </div>
                    <div class="campo">
                        <span class="campo-label">Banco</span>
                        <strong class="campo-valor">{{ valorOuTraco(dados()?.banco) }}</strong>
                    </div>
                    <div class="campo">
                        <span class="campo-label">Data Emissão</span>
                        <strong class="campo-valor">{{ valorOuTraco(dados()?.dataEmissao) }}</strong>
                    </div>
                    <div class="campo">
                        <span class="campo-label">Data Vencimento</span>
                        <strong class="campo-valor">{{ valorOuTraco(dados()?.dataVencimento) }}</strong>
                    </div>
                    <div class="campo">
                        <span class="campo-label">Convênio</span>
                        <strong class="campo-valor">{{ valorOuTraco(dados()?.numeroConvenio) }}</strong>
                    </div>
                    <div class="campo">
                        <span class="campo-label">Identificador Pagamento</span>
                        <strong class="campo-valor">{{ valorOuTraco(dados()?.identificadorPagamento) }}</strong>
                    </div>
                </div>
            </app-card-content>
        }

        <!-- Documento -->
        <app-card-content [headerColor]="false" [title]="'Documento'" [icon]="iconeDaSecao('Documento')" [subtitle]="subtituloDaSecao('Documento')">
            @if (possuiAnexo()) {
                <button type="button" class="campo-link-botao" (click)="onVisualizarAnexo($event)" aria-label="Visualizar anexo" title="Visualizar anexo">
                    <i class="pi pi-paperclip"></i>
                    <span>Visualizar anexo</span>
                </button>
            } @else {
                <strong class="campo-valor">-</strong>
            }
        </app-card-content>
    </form>
</div>

<p-dialog
    appDialogoPadrao="pi pi-paperclip"
    descricao="Documento anexado ao registro."
    [visible]="exibirDialogAnexo()"
    (visibleChange)="exibirDialogAnexo.set($event)"
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    header="Visualização de anexo"
    (onHide)="fecharDialogAnexo()"
>
    @if (blobAnexo(); as blobAnexo) {
        <app-visualizador-pdf [src]="blobAnexo" [fileName]="nomeArquivoAnexo()" [showAll]="false"></app-visualizador-pdf>
    } @else {
        <div class="feedback">Nenhum anexo disponível para visualização.</div>
    }
</p-dialog>
